let jobTimer;
const jobs = [];
let jobSeed = 1;
const handlers = [];

const broadcastChannel = new BroadcastChannel('cpm');

broadcastChannel.onmessage = messageEvent => {
    const message = messageEvent.data;

    if (!message.jobId) {
        console.warn('received invalid message');

        return;
    }

    if (message.isRequest) {
        const handler = handlers[message.action];

        if (!handler) {
            console.warn(`received message[${message.action}] but could not be handled`);

            return;
        }

        const response = getReturnMessage(message);
        const promise = handler(message);

        if (promise instanceof Promise) {
            promise
                .then(data => {
                    response.data = data;
                    broadcastChannel.postMessage(response);
                })
                .catch(error => {
                    response.error = {
                        code: 1,
                        message: error.message,
                    };
                    broadcastChannel.postMessage(response);
                });
        }

        return;
    }

    const job = getJob(message.jobId);

    if (!job) {
        console.warn('received message but could not associate with a job');

        return;
    }

    job.onDone(message);
};

function getJob(id) {
    const job = jobs[id];

    if (job) {
        delete jobs[id];
    }

    return job;
}

function registerJob(message, onDone) {
    const job = {
        id: message.jobId,
        action: message.action,
        startDate: message.startDate,
        timeout: message.timeout,
        onDone,
    };

    jobs[job.id] = job;

    if (!jobTimer) {
        jobTimer = setTimeout(checkForExpiredJobs, 1000);
    }
}

function isExpired(job) {
    if (!job.startDate) {
        return true;
    }

    return Date.now() - job.startDate > job.timeout;
}

function checkForExpiredJobs() {
    for (const index in jobs) {
        if (!Object.hasOwn(jobs, index)) {
            continue;
        }

        const job = jobs[index];

        if (isExpired(job)) {
            job.onDone({
                isRequest: false,
                action: job.action,
                error: {
                    code: 1,
                    message: 'timeout',
                },
                data: null,
                startDate: job.startDate,
                timeout: job.timeout,
                jobId: job.id,
            });
            delete jobs[index];
        }
    }

    clearTimeout(jobTimer);
    jobTimer = null;

    if (jobs.some(Boolean)) {
        jobTimer = setTimeout(checkForExpiredJobs, 1000);
    }
}

function getReturnMessage(message) {
    return {
        isRequest: false,
        action: message.action,
        data: null,
        error: null,
        startDate: Date.now(),
        timeout: null,
        jobId: message.jobId,
    };
}

/**
 * Register an action handler for requests received from another CPM browser context.
 */
export function registerHandler(action, handler) {
    handlers[action] = handler;
}

/**
 * Send a request to another CPM browser context and resolve its response.
 */
export function sendRequest(action, data, timeoutMilliseconds = 1000 * 10) {
    const request = {
        isRequest: true,
        action,
        data,
        startDate: Date.now(),
        timeout: timeoutMilliseconds,
        jobId: ++jobSeed,
    };

    return new Promise((resolve, reject) => {
        registerJob(request, response => {
            if (response.error) {
                reject(response);

                return;
            }

            resolve(response);
        });
        broadcastChannel.postMessage(request);
    });
}
